/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const COMMITTEE_CAN_ABILITY = [
  //Route Access
  ["read", "MyProfile"],
  ["read", "DashboardOverview"],
  ["read", "DashboardIssuerAnalysis"],
  ["read", "DashboardVerifierAnalysis"],
  ["read", "UserList"],
  ["read", "CommDisList"],
  ["read", "HoldersGroups"],
  ["read", "HoldersGroups.Holders"],
  ["read", "Holders"],
  ["read", "Credential"],
  ["read", "HoldersBatchImport"],
  ["read", "IssuedCredentialList"],
  ["read", "CredentialList"],
  ["read", "IssueNewCredential"],
  ["read", "IssuedNetworkGraph"],
  ["read", "Placeholder"],
  ["read", "ProfileUpdateStepper"],
  ["read", "InvitationOverview"],
  ["read", "CommDisList"],
  ["read", "InviteMasqueraderPurchase"],
  ["read", "OrgProfile"],
  ["read", "AboutMe"],

];

export const COMMITTEE_CANNOT_ABILITY = [
  //Route Access Denial
  //  ["read", "Button"],
];
